import { styled } from '@nykaa/ui-components';

import BaseOverlaySheet from 'shared/components/OverlaySheet';
import BaseModal from 'shared/components/Modal';

export const DesktopModal = styled(BaseModal)`
  width: 480px;
  max-width: calc(100% - ${({ theme }) => theme.spacing.spacing80});
  max-height: 420px;
  border-radius: ${({ theme }) => theme.borders.radius40};
  overflow: hidden;
`;

export const BottomSheet = styled(BaseOverlaySheet)`
  animation-duration: 0.3s;
  background: transparent;
  border-radius: ${({ theme }) => `${theme.spacing.spacing80} ${theme.spacing.spacing80} 0 0`};
  padding: ${({ theme }) => `0 ${theme.spacing.spacing40} ${theme.spacing.spacing40}`};
  top: initial;
  width: 100%;
`;

export const SheetContent = styled.section`
  background: ${({ theme }) => theme.colors.overlayBg};
  border-radius: ${({ theme }) => theme.borders.radius40};
  color: ${({ theme }) => theme.colors.textPrimary};
  max-height: 80vh;
  overflow-y: auto;
  width: 100%;
`;

export const DesktopSheetContent = styled(SheetContent)`
  max-height: 420px;
`;

export const BottomSheetHeader = styled.div<{ showBorder: boolean; }>`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing40};
  padding: ${({ theme }) => theme.spacing.spacing80};
  background: ${({ theme }) => theme.colors.overlayBg};
  border-bottom: ${({ showBorder, theme }) =>
    showBorder ? `1px solid ${theme.colors.surface10}` : '0'};
`;

export const CloseButton = styled.button`
  display: flex;
  padding: 0;
  border: 0;
  background: transparent;
`;

export const BackButton = CloseButton;

export const SellerTitle = styled.h3`
  margin: 0;
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const SellerDetails = styled.div`
  padding: ${({ theme }) => `${theme.spacing.spacing80}`};
`;

export const DetailLabel = styled.p`
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0 ${theme.spacing.spacing20}`};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};

  &:first-child {
    margin-top: 0;
  }
`;

export const DetailValue = styled.p`
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const SelectSellerButton = styled.button`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  padding: ${({ theme }) => theme.spacing.spacing40};
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  border-radius: ${({ theme }) => theme.borders.mwebButtonBorderRadius};
  ${({ theme }) => theme.typography.buttonMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  background: transparent;
`;

export const SellerRow = styled.div<{ isDefaultVendor: boolean; }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto auto;
  column-gap: ${({ theme }) => theme.spacing.spacing80};
  padding: ${({ theme }) => theme.spacing.spacing80};
  background: ${({ isDefaultVendor, theme }) =>
    isDefaultVendor ? theme.colors.textDecorative : 'transparent'};
`;

export const SellerRowContent = styled.div`
  grid-column: 1;
  grid-row: 1 / span 3;
  min-width: 0;
`;

export const SellerName = styled.button`
  max-width: 100%;
  padding: 0;
  overflow: hidden;
  border: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  background: transparent;
  ${({ theme }) => theme.typography.bodyMedium};
  text-align: left;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DeliveryText = styled.p`
  margin: ${({ theme }) => `${theme.spacing.spacing20} 0`};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SellerPrice = styled.p`
  margin: 0;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};

  s {
    ${({ theme }) => theme.typography.bodyXSmall};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  span {
    ${({ theme }) => theme.typography.bodyXSmall};
    margin-left: ${({ theme }) => theme.spacing.spacing20};
    color: ${({ theme }) => theme.colors.positivePrimary};
  }
`;

export const AddToBagButton = styled(SelectSellerButton)`
  position: relative;
  align-self: start;
  grid-column: 2;
  grid-row: 1 / span 3;
  width: auto;
  margin-top: 0;
  padding: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing40}`};
  white-space: nowrap;
`;

export const ButtonLabel = styled.span<{ isLoading: boolean; }>`
  visibility: ${({ isLoading }) => (isLoading ? 'hidden' : 'visible')};
`;

export const LoaderContainer = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
`;
